<template>
	<div class="container">
		
		<study />

	</div>
</template>

<script>
import Study from "@/components/study/study";

export default {
	name: "view-study",
	components: { Study }
};
</script>

<style lang="stylus" scoped>

	
</style>